import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [my, setMy] = useState(null);
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchUserData = async () => {
      if (!accessToken) return;

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/account/user`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // Check if the fetched data differs from the one stored in localStorage
        const storedUser = localStorage.getItem("user");
        const fetchedUser = response.data;

        // If the fetched user data is different from what's in localStorage, update it
        if (storedUser) {
          const parsedStoredUser = JSON.parse(storedUser);
          const hasChanges = Object.keys(fetchedUser).some(
            (key) => parsedStoredUser[key] !== fetchedUser[key]
          );

          if (hasChanges) {
            localStorage.setItem("user", JSON.stringify(fetchedUser));
            setMy(fetchedUser); // Update state with new data
          }
        } else {
          // If no user data is found in localStorage, just save the fetched data
          localStorage.setItem("user", JSON.stringify(fetchedUser));
          setMy(fetchedUser);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    // Initial fetch
    fetchUserData();
    
    // Refetch data every 30 seconds
    const interval = setInterval(fetchUserData, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [accessToken]);

  return <MyContext.Provider value={my}>{children}</MyContext.Provider>;
};

// Custom hook for easy access to user data
export const useMy = () => useContext(MyContext);
